import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=1d3831f6&scoped=true&"
import script from "./menus.vue?vue&type=script&lang=js&"
export * from "./menus.vue?vue&type=script&lang=js&"
import style0 from "./menus.vue?vue&type=style&index=0&id=1d3831f6&prod&scoped=true&lang=less&"
import style1 from "./menus.vue?vue&type=style&index=1&id=1d3831f6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3831f6",
  null
  
)

export default component.exports